import { useLocation, useNavigate } from "react-router-dom";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import React, {ChangeEvent, useEffect, useReducer, useRef, useState} from 'react';
import { TextField, Button, Stack, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, MenuItem, Alert } from '@mui/material';
import './Record.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

import {Helmet} from "react-helmet";

import environment from "../../../environment/environment";
import APIService from "../../../services/api.service";
import axios from "axios";
import { CacheService } from "../../../common/services/cache.service";
import { Parks } from "../../../models/ticNum";
import { userState } from "../../../atoms/user";
import { useRecoilState } from "recoil";
import { tokenState } from "../../../atoms/token";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Link } from "react-router-dom";
import { styled } from '@mui/material/styles';

const AddRecord = () => {
  const initialForm = {};
  const [file, setFile] = useState<File>();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const navigate = useNavigate();
 
  const [parks, setParks] = useState([]);
  const [park, setPark] = useState<any>({});
  const [token, setToken] = useRecoilState(tokenState);

  const [userInfo, setuserInfo] = useRecoilState(userState);
  const [fileUploaded, setFiledUploaded] = useState(false);
  const [acknowledgementRead, setAcknowledgementRead] = useState(false);

  const [form, setForm] = useReducer(
    (form, updates) => ({...form, ...updates}),
    initialForm
  );

  const [securityTypes, setSecurityTypes] = useState([]);

  const getSecurityTypes= () => {

    let url = `${environment.npgAPI}list?id=eticdoctype&format=JSON`;
    const apiService = new APIService<any>(axios, new CacheService, url, token);

    apiService.getAnyAsync().then((res:any) => {
      setSecurityTypes(res.map((item) => ({ label: item.description, value: item.label })));
    });
  }

  useEffect(() => {
    getSecurityTypes();
    getParks();
  }, []);

  const getParks = () => {
    let url = `${environment.npgAPI}list?id=eticpark&format=JSON`;
    const apiService = new APIService<any>(axios, new CacheService, url, token);

    apiService.getAnyAsync().then((res:any) => {
      console.log('parks', res);

      setParks(res);
    });
  }

  const handleUploadClick = () => {
    // 👇 We redirect the click event onto the hidden input element
    inputRef.current?.click();
  }

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) {
      return;
    }

    setFile(e.target.files[0]);
    setForm({["File"]: e.target.files[0]});
    //setForm({["FileName"]: e.target.files[0].name});
    setForm({["UserId"]: userInfo?.userId});
  }

  const handleSubmit = (event) => {
    event.preventDefault();
  }
  
  const onSaveClick = () => {
    setFiledUploaded(true);
    clearData();
    let formData = {
      userUpload: {}
    };
    let obj = new FormData();

    // add form data to formdata userupload object
    Object.keys(form).forEach(key => {
      if(key !== 'File')
        formData.userUpload[key] = form[key];
      else
        formData[key] = form[key];
    });
    let json = JSON.stringify(form);
    obj.append('userUpload', json);
    obj.append('File', file);
    console.log('form data', obj);
    const url = `${environment.eticApiUrl}CreateUserUpload`;
    axios.post(url,obj, { headers: {
      'Content-Type': 'multipart/form-data'}}).then(res => {
        console.log(res);
        
        setFiledUploaded(true);
      });

  }

  const clearData = () => {
    setForm(initialForm);
    
    setForm({["File"]: null});
    //setForm({["FileName"]: ""});
    //setForm({["UserId"]: ""});
    setForm({['parkId']: ""});
    setForm({['title']: ""});
    setForm({['docType']: ""});
    setForm({['ticNumber']: ""});
    setForm({['parkName']: ""});

    setFile(null);
  }

  const onCancelClick = () => {
    navigate('/', {state: {}})
  }

  const onBackClick = () => {
    navigate('/', {state: {}})
  }

  const newFileClick = () => {
    setFiledUploaded(false);
  }

  const handleChange = (fieldName: string, value: any) => {
    setForm({[fieldName]: value});
    const parkCode = parks.find(x => x.name === value)?.code;
    
     if(fieldName === 'parkName') {
      setPark(parks.find(x => x.name === value));
      setForm({['parkId']: parks.find(x => x.name === value).id});
     }

     /*if(fieldName === 'docType') { 
      if(value === 'ARG') {
        setForm({['ticDocTypeId']: 5});
        setForm({['docTypeId']: 5});
        setForm({['docType']: 'ARG'});
      }
      else if(value === 'PUB') {
        setForm({['ticDocTypeId']: 1});
        setForm({['docTypeId']: 1});
        setForm({['docType']: 'PUB'});
      }
      else if(value === 'RES') {
        setForm({['ticDocTypeId']: 2});
        setForm({['docTypeId']: 2});
        setForm({['docType']: 'RES'});
      }
      else if(value === 'SENS') {
        setForm({['ticDocTypeId']: 3});
        setForm({['docTypeId']: 3});
        setForm({['docType']: 'SNS'});
      }
      else if(value === 'WRK') {
        setForm({['ticDocTypeId']: 4});
        setForm({['docTypeId']: 4});
        setForm({['docType']: 'WRK'});
      }
     }*/
    console.log('update form', form);
    console.log('update log', parkCode);
  }

  const onlyNumbers = (e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') };

  const convertDate = (lastModified) => {
    const date = new Date(lastModified);

    return date.toDateString();
  }

  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));

  const handleAcknowledge = () => { 
    setAcknowledgementRead(true);
  }
  console.log(' form', form);

  return (

    <div className="standard-margin center">
      <Helmet>
        <meta charSet="utf-8"/>
        <title>Add Record</title>
      </Helmet>

      <Card sx={{ minWidth: 275 }} >
        <CardContent className="record-form center" style={{marginBottom: '50px'}}>
          { !acknowledgementRead &&
            <>
              <div id="uploadContent">
                  <h2>Preparing Your Documents</h2>
                  <p>Before uploading, documents must be prepared as follows:</p>
                  <ul>
                      <li>You must scan original documents if possible, not copies. If the document is in color — scan in color.</li>
                      <li>Be sure to scan all document pages.</li>
                      <li>Please do not make a separate file for each page of the document. Each document must be scanned into 
                      <span className="lessBold"><i>ONE</i></span> file (that is, a multi-page
                          <abbr title="Portable Document Format">PDF</abbr>
                          document). </li>
                      <li>Check your scan to see that everything in the original document is legible, including text, stamps, numbers, or similar items. 
                          Illegibility may be unavoidable if the original document is old or faded. Please ensure the scan has value.</li>
                      <li>If you are unable to produce a quality scan, please submit your documents via regular mail. Instructions for mailing can be found on the 
                          <a href="AboutUs/ContactUs.aspx#shipping" target="_blank">Contact Us</a> page.
                      </li>
                      <li>We do not recommend that you take photos of your documents.</li>
                      <li>We can only accept 1 <abbr>PDF</abbr> (Portable Document Format) file per upload form or 1 .zip compressed folder (note: .zip folders are not accessible on eTIC2;
                          your .zip folder will be downloaded, and the contents extracted and uploaded to eTIC2 individually if the files fit the scope.
                          Your uploaded .zip will be rejected but the files saved.)
              
                      </li>
                      <li>TIC staff will contact you if there are any questions or problems with your files.</li>
                  </ul>
                  <h2>Uploading Your Prepared Files</h2>
                  <p><span className="lessBold">If you are uploading more than 10 files, please contact eTIC at <a href="mailto:etic@nps.gov" target="_blank">etic@nps.gov</a> to set up a bulk upload library to save you time.</span></p>
                  <p>Once you've prepared and scanned your documents into <abbr>PDF</abbr> files, it's time to use the uploading function.</p>
                  <ul>
                      <li>Complete the form with the required information: Park and Title. Optional fields include: Proposed Security Type, 
                          TIC Number (if one has been reserved for the file being uploaded), PMIS number, and any comments.</li>
                      <li>When attaching the file, use either the 'select' button to browse for your file or drag and drop it into the ‘select’ field
                  <ul>
                      <li><span className="lessBold">Tip:</span> Give your PDF file a reasonable name that will reflect the contents.</li>
                      <li><span className="lessBold">Tip:</span> The file must originate from your local drive; you cannot upload from OneDrive.</li>                                               
                  </ul>
                              </li>
                              <li>The size of your overall upload cannot exceed the <span className="lessBold">maximum of 2 gigabytes.</span>
                  <ul>
                      <li><span className="lessBold">Tip:</span> Remember that once you've uploaded your documents, you can no longer delete them.</li>
                      <li><span className="lessBold">Tip:</span> A record of uploads is recorded in your My Account My Uploads page.</li>
                  </ul>
                      </li>
                      <li>Once uploaded, TIC staff will begin to process your upload and add them to eTIC in a timely fashion. 
                          TIC reserves the right to accept or reject files uploaded into the eTIC2 File Upload system.</li>
                  </ul>
              </div>

              <Stack spacing={2} direction="row" sx={{marginBottom: 2}}>
                <Button 
                  id="agree"
                  variant="outlined" 
                  className=""         
                  startIcon={<FontAwesomeIcon icon={["fas", "arrow-right"]} />}
                  onClick={handleAcknowledge}>
                    Acknowledge
                </Button>
              </Stack>
            </>
          }

          { acknowledgementRead &&
          <>
            <h2>Upload Form</h2>
            { !fileUploaded &&
              <>
                <Stack spacing={1} direction="row" sx={{marginBottom: 2}}>

                  <Tooltip title={(!form?.title || !form?.parkName || !form?.docType || !file ? 'This save button will be enabled when the required files are filled in AND you have uploaded a file.': null )} arrow>
                    <span>
                      <Button
                          id="save"
                          variant="contained"
                          className=""
                          startIcon={<FontAwesomeIcon icon={["fas", "floppy-disk-circle-arrow-right"]} />}
                          disabled={!form?.title || !form?.parkName || !form?.docType || !file} 
                          onClick={() => { onSaveClick(); }}>
                        Save
                      </Button>
                    </span>
                  </Tooltip>
  
                  <Button 
                    id="upload"
                    variant="contained"
                    className=""         
                    startIcon={<FontAwesomeIcon icon={["fas", "file-upload"]} />}
                    onClick={handleUploadClick}>
                      Upload File
                  </Button>
  
                  <input
                    type="file"
                    ref={inputRef}
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                  />
  
                </Stack>
              
                { file &&
                  <>
                    <h2>File Details</h2>
                    <p>File Name: {file.name}</p>
  
                    <p>File Type: {file.type}</p>
  
                    <p>
                        Last Modified:{" "}
                        {convertDate(file.lastModified)}
                    </p>
                  </>
                }
  
                <form onSubmit={handleSubmit} aria-disabled className="record-form">
                  <Stack spacing={2} direction="column" sx={{marginBottom: 2}}>            
                      <TextField
                          type="text"
                          variant='outlined'
                          color='primary'
                          label="Park Name"
                          disabled={!parks.length}
                          onChange={e => handleChange('parkName', e.target.value)}
                          value={form?.parkName || ''}
                          sx={{width: 600}} 
                          required
                          select>
                          {parks.map((option) => (
                            <MenuItem key={option.id} value={option.name}>
                              {option.name}
                            </MenuItem>
                          ))}
                      </TextField>
                  
                      <TextField
                          type="text"
                          variant='outlined'
                          color='secondary'
                          label="Park Code"
                          sx={{width: 600}} 
                          value={park?.code || ''}
                          disabled={true}
                          InputLabelProps={{shrink: park.code}}
                      />
                      
                      <TextField
                          type="text"
                          variant='outlined'
                          color='secondary'
                          label="Park Previous Name"
                          sx={{width: 600}} 
                          //onChange={e => setPassword(e.target.value)}
                          value={park?.previousName || ''}
                          disabled={true}
                          
                      />
                      <TextField
                          type="text"
                          variant='outlined'
                          color='secondary'
                          label="Region Name"
                          sx={{width: 600}} 
                          //onChange={e => setDateOfBirth(e.target.value)}
                          value={park?.regionName || ''}
                          disabled={true}
                          
                      />
                  </Stack>
  
                  <Stack spacing={2} direction="column" sx={{marginBottom: 2}}>
                    <TextField
                        type="text"
                        variant='outlined'
                        color='secondary'
                        label="Title"
                        onChange={e => handleChange('title', e.target.value)}
                        value={form?.title}
                        sx={{width: 600}} 
                        required
                        InputLabelProps={{shrink: form.title}}
  
                    />
  
                    <FormControl fullWidth>
                      <InputLabel id="doc-type-label">Proposed Security Type *</InputLabel>
                      <Select
                        labelId="doc-type-label"
                        id="doc-type"
                        value={form?.docType}
                        sx={{width: 600}} 
                        variant='outlined'
                        color='primary'
                        required
                        label="Proposed Security Type"
                        onChange={e => handleChange('docType', e.target.value)}
                        startAdornment={
                          <InputAdornment position="start">
                            <HtmlTooltip
                              title={
                                <React.Fragment>
                                  <span>
                                    {"Not sure what security type to recommend? Please review our Security Guidelines page "}
                                  </span>
                                  <Link to={"/securityGuidelines"}>
                                    eTIC (nps.gov)
                                  </Link>
                                </React.Fragment>
                              }
                            >
                            <FontAwesomeIcon icon={["fas", "info-circle"]} />   
  
                           </HtmlTooltip>
                          </InputAdornment>
                        }
                        >
                          {securityTypes.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                            ))
                          }
                      </Select>
                    </FormControl>
                    <FormControl sx={{width: 600}}  variant="outlined">        
                      <InputLabel htmlFor="outlined-adornment-password">TIC Number</InputLabel>
                      <OutlinedInput
                        id="TicNumber"
                        type="text"
                        required
                        color='secondary'
                        label="TIC Number"
                        onChange={e => handleChange('ticNumber', e.target.value)}
                        inputProps={{maxLength: 6}}
                        sx={{ '.MuiFormLabel-root': {marginTop: '-5px'},
                        '.MuiInputLabel-root': {marginTop: '-5px'},
                        '.MuiInputLabel-formControl': {marginTop: '-5px'}
                      }}
                        value={form?.ticNumber || ''}
                        startAdornment={
                          <InputAdornment position="start">
                            <Tooltip title="If a TIC Number has already been reserved for the file you are uploading, please provide the TIC Number. If no TIC Number has been reserved, one will be assigned when the file is reviewed and cataloged into eTIC">
                              <FontAwesomeIcon icon={["fas", "info-circle"]} />            
                            </Tooltip>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                         
                    <TextField
                        type="text"
                        variant='outlined'
                        color='secondary'
                        label="PMIS #"
                        onChange={e => handleChange('pmisNumber', e.target.value)}
                        value={form?.pmisNumber}
                        inputProps={{maxLength: 6}}
                        onInput={(e) => onlyNumbers(e) } 
                        sx={{width: 600}} 
  
                    />
                  </Stack>
                  <TextField
                      type="text"
                      variant='outlined'
                      color='secondary'
                      label="Comments"
                      onChange={e => handleChange('comments', e.target.value)}
                      value={form?.comments || ''}
                      fullWidth
                      multiline
                      sx={{width: 600}}
                      size="medium"
                      inputProps={{maxLength: 1000}}
                  />
                </form>
              </>
            }
          </>
          }
          

        { fileUploaded && 
          <>
            <Alert icon={<FontAwesomeIcon icon={["fas", "check"]} />} severity="success">
              Success! File Uploaded!
            </Alert>

            <Stack spacing={2} direction="row" sx={{marginTop: 2}}>
              <Button
                    id="new"
                    variant="contained"
                    className="center"
                    startIcon={<FontAwesomeIcon icon={["fas", "plus"]} />}
                    onClick={() => { newFileClick(); }}>
                  Upload New File
              </Button>

              <Button
                    id="new"
                    variant="contained"
                    className="center"
                    startIcon={<FontAwesomeIcon icon={["fas", "arrow-right"]} />}
                    onClick={() => { navigate('/myUploads') }}>
                  View My Uploads
              </Button>
            </Stack>      
          </>
        }

        </CardContent>
      </Card>
    </div>
  );
}

export default AddRecord;